import React, {useState} from 'react'
import ContainerLayout from '../../../../components/layout/ContainerLayout'
import TableHeader from '../../../../components/table/TableHeader'
import TableItem from '../../../../components/table/TableItem'
import Text from '../../../../components/text/Text'
import Span from '../../../../components/text/Span'
import MoreButton from '../../../../components/button/MoreButton'
import {ICopyOrder} from '../../../../apis/copier/copierDetail'
import {useDisplayNumber} from '../../../../utils/number'
import {useTime} from '../../../../utils/time'
import {useColor, useTag} from '../../../../utils/etc'

interface IProps {
    className?: string
    title: string
    data?: ICopyOrder[]
    defaultCount?: number
}

const GRID = 'grid-cols-[auto_110px_110px_140px] sm:block sm:space-y-[5px]'

// admin/copy/copier/:id 가 함께 주는 orders / leader_orders를 그대로 그린다.
// (예전에는 key/history/:id 를 봇 id로 호출해 항상 빈 목록이었다.)
const CopyOrderHistoryContainer: React.FC<IProps> = ({className, title, data, defaultCount = 5}) => {
    const {floorBalance} = useDisplayNumber()
    const {localTimeString} = useTime()
    const {renderHistoryTag} = useTag()
    const {getNumberColor} = useColor()
    const [showAll, setShowAll] = useState(false)

    const list = showAll ? data : data?.slice(0, defaultCount)

    return (
        <ContainerLayout title={title} className={`${className}`}>
            <TableHeader className={`${GRID} sm:hidden`}>
                <Text>Symbol</Text>
                <Text>
                    <Span className={'block'}>Price</Span> <Span className={'block'}>Amount</Span>
                </Text>
                <Text className={'text-center'}>PNL / Fee</Text>
                <Text className={'text-right'}>Create At</Text>
            </TableHeader>

            {list?.map(item => (
                <TableItem key={item?.id} className={GRID}>
                    <div className={'flex items-center gap-x-[7px] truncate'}>
                        <div className={`${renderHistoryTag(item?.type)}`}>{item?.type}</div>
                        <Text className={'text-ti2 truncate'}>{item?.normalized_symbol}</Text>
                        {item?.position_side && (
                            <Text className={'text-body3 text-font03 uppercase'}>{item?.position_side}</Text>
                        )}
                    </div>
                    <div className={'sm:space-y-[5px]'}>
                        <Text>
                            <Span className={'hidden sm:inline'}>Price : </Span>
                            {floorBalance(item?.price_in_base, 10000)}
                        </Text>
                        <Text className={'text-ti3 sm:text-ti2 text-font03 sm:text-font01'}>
                            <Span className={'hidden sm:inline'}>Amount : </Span>
                            {floorBalance(item?.amount, 10000, false)}
                        </Text>
                    </div>
                    <div className={'text-center sm:text-left'}>
                        <Text className={`text-ti3 ${getNumberColor(item?.pnl)}`}>
                            <Span className={'hidden sm:inline'}>PNL : </Span>
                            {floorBalance(item?.pnl, 10000, false)}
                        </Text>
                        <Text className={'text-body3 text-font03'}>
                            <Span className={'hidden sm:inline'}>Fee : </Span>
                            {floorBalance(item?.fee, 10000, false)}
                        </Text>
                    </div>
                    <div className={'text-right sm:text-left'}>
                        <Text className={'text-body3 text-font03'}>
                            {item?.created_at ? localTimeString(item?.created_at) : '-'}
                        </Text>
                    </div>
                </TableItem>
            ))}

            {!data?.length && (
                <TableItem className={'text-center'}>
                    <div>
                        <Text>No Items</Text>
                    </div>
                </TableItem>
            )}

            {data?.length > defaultCount && (
                <div className={'text-center'}>
                    <MoreButton
                        onClick={() => setShowAll(!showAll)}
                        text={showAll ? 'Fold' : `View All (${data?.length})`}
                    />
                </div>
            )}
        </ContainerLayout>
    )
}

export default CopyOrderHistoryContainer
